import gql from 'graphql-tag';

const GET_CREDENTIALS = gql`
    query getCredentials ($keys: [String]) {
        getCredentials (keys: $keys) {
            status
            message
            data {
                key
                value
            }
        }
    }
`;

export default GET_CREDENTIALS;
